import React from "react"
import Main from "./Project/Main"
import "bootstrap/dist/css/bootstrap.min.css"
// import Movie from "./Project/Movie"
import {UserProvider} from "./Project/UserContext"
// import SideBar from "./Project/SideBar"


function App() {
  return (
    <div>
      {/* <SideBar/> */}
      <UserProvider>
      <Main/>
      </UserProvider>
      {/* <Movie/>
      {/* <Games/> */}
    </div>
  );
}

export default App;
